var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 81,
  height: 81,
  viewBox: "0 0 81 81"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "worldwide",
  transform: "translate(0 -0.067)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1742",
  "data-name": "Group 1742",
  transform: "translate(3.172 3.019)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_362",
  "data-name": "Path 362",
  d: "M307.776,35.284,303.557,38.1l-7.031-1.406-4.218-1.406-5.625,1.406-4.218-1.406,2.812-5.625H290.9l5.512-2.756A40.274,40.274,0,0,1,307.776,35.284Z",
  transform: "translate(-241.197 -25.581)",
  fill: "#03aa6f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_363",
  "data-name": "Path 363",
  d: "M54.7,22.682,53.3,26.9l-4.218,1.406-4.218,7.031L37.83,39.556l-9.843,1.406V45.18L30.8,47.992v5.625L26.581,50.8l-4.218-2.812-2.447-7.354A40.752,40.752,0,0,1,42.274,18.6l3.993,2.672Z",
  transform: "translate(-19.916 -18.604)",
  fill: "#03aa6f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_364",
  "data-name": "Path 364",
  d: "M100.119,224.6l-1.406,7.031-5.625,5.625v4.218l-5.625,4.218v7.031l-4.218-1.406-2.812-7.031V230.221L73.4,228.815,70.59,223.19v-4.218l2.812-2.812,4.218-4.218,2.812,5.625h9.843l4.218,7.031Z",
  transform: "translate(-62.519 -181.676)",
  fill: "#03aa6f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_365",
  "data-name": "Path 365",
  d: "M306.4,117.4a40.738,40.738,0,0,1-2.25,43.407l-3.8-3.8V151.39l-2.812-5.625-2.812-5.625v-5.625l-4.219-2.812-5.625,1.406-9.843-4.218-1.406-9.843,4.219-4.218h8.437l2.812,4.218,8.437,1.406,8.437-2.812Z",
  transform: "translate(-233.777 -100.032)",
  fill: "#03aa6f"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_366",
  "data-name": "Path 366",
  d: "M48.855,14.036l5.584-1.4,4.188,1.4,6.98,1.4,4.188-2.794a39.9,39.9,0,0,1,6,8.145l-.419.238L67,23.816l-8.376-1.4-2.792-4.191H47.459l-4.188,4.191,1.4,9.779,9.772,4.191,5.584-1.4,4.188,2.794v5.588L67,48.962l2.792,5.588v5.588l3.769,3.772A40.49,40.49,0,0,1,3.149,24.891L5.578,32.2l4.188,2.794,4.188,2.794L11.162,40.58v4.191l2.792,5.588,6.98,1.4v13.97l2.792,6.985,4.188,1.4V67.123L33.5,62.932V58.741l5.584-5.588,1.4-6.985H34.894l-4.188-6.985H20.934l-2.792-5.588-4.188,4.191V32.2L11.162,29.4V25.212l9.772-1.4,6.98-4.191L32.1,12.639l4.188-1.4,1.4-4.191-8.376-1.4L25.346,3A40.46,40.46,0,0,1,58.515,4.313L53.043,7.051H47.459l-2.792,5.588Z",
  transform: "translate(0)",
  fill: "#86daf1"
}))));
export default __webpack_public_path__ + "static/media/Globalflag.6daa2bfb.svg";
export { SvgComponent as ReactComponent };